import React from 'react'

export const Terms = (): JSX.Element => {
  return <div>terms</div>
}
